import { Grid } from "@mui/material";
import React from "react";
import { AutocompleteInput, DateTimeInput, ReferenceArrayInput, SelectInput, TextInput, required, useRecordContext } from "react-admin";
import { CountryEnum, StatusEnum } from "src/common/enum";
import { PhoneInput, StateInput } from "src/components/input";
import { Edit, FormTab, TabbedForm } from "src/enterprise/ra-rbac";
import { GroupEditComponent } from ".";
import Transformer from "../../common/Transformer";
import { FileInput } from "../../components/file-input/FileInput";
import { DualListInput } from "src/enterprise/ra-relationships";

export const GroupEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt", "userIds", "uuid"],
      update: {
        users: data.user_ids
      },
    });

    return data;
  };

  return (
    <Edit
      component={GroupEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <TabbedForm>
        <FormTab label="General" name="general">
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item lg={2} sm={12}>
            <TextInput source="id" disabled />
          </Grid>
          <Grid item lg={4} sm={12}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item lg={6} sm={12}>
            <TextInput source="email" validate={required()} />
          </Grid>
          <Grid item lg={6} sm={12}>
            <PhoneInput source="phone" label="Phone" validate={required()}/>
          </Grid>
          <Grid item lg={6} sm={12}>
            <PhoneInput source="mobile" label="Mobile"  />
          </Grid>
          <Grid item lg={6} sm={12}>
            <TextInput source="website"  />
          </Grid>
          <Grid item lg={6} sm={12}>
            <SelectInput source="status" choices={StatusEnum} validate={required()} />
          </Grid>
          <Grid item sm={12}>
            <ResaleFileInput/>
          </Grid>
          <Grid item lg={6} sm={12}>
            <TextInput source="resale_number" />
          </Grid>
          <Grid item lg={6} sm={12}>
            <DateTimeInput source="resale_date_established" />
          </Grid>

          <Grid item lg={6} sm={12}>
            <DateTimeInput source="created_at" disabled />
          </Grid>
        </Grid>
        </FormTab>


        <FormTab label="Address" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>

            <Grid item sm={12} lg={4}>
              <TextInput source="street_address" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={4}>
              <TextInput source="city" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={4}>
              <TextInput source="zip" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <AutocompleteInput
                source="country"
                size="small"
                choices={CountryEnum.slice(1)}
                sx={{
                  "#state": { width: "100%" },
                }}
                emptyValue={""}
                validate={required()}
              />
            </Grid>
            <Grid item sm={12} lg={6}>
              <StateInput />
            </Grid>
            
          </Grid>
        </FormTab>


        <FormTab name="users" label="Users">

            <ReferenceArrayInput
              source="user_ids"
              reference="admin/users"
              perPage={999}
            >
              <DualListInput
                label="Users"
                optionText={(record) => record.first_name+" "+record.last_name+" ("+record.email+")"}
                dense={true}
              />
            </ReferenceArrayInput>
        </FormTab>

      </TabbedForm>
    </Edit>
  );
};

const ResaleFileInput = () => {
  const record = useRecordContext();

  return (
    <FileInput
      source="resale_file"
      multiple={false}
      fileTypes={["PDF", "DOCX"]}
      label="Resale file"
      inputType="document"
      previewWidth={"fit-content(40%)"}
      path={`admin/groups/${record.id}/media`}
      lockPath
    ></FileInput>
  );
};




